import { z } from 'zod';

// Most endpoints in this API are company-scoped, so this path shape recurs in
// every domain. Declare it here once rather than per domain.
export const CompanyPathSchema = z.object({ companyId: z.string() });
